import { render } from "./AccessForbidden.vue?vue&type=template&id=b88fe58e&scoped=true"
import script from "./AccessForbidden.vue?vue&type=script&lang=js"
export * from "./AccessForbidden.vue?vue&type=script&lang=js"

import "./AccessForbidden.vue?vue&type=style&index=0&id=b88fe58e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88fe58e"]])

export default __exports__